import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/PillButton.module.css';

const PillButton = ({ children, onClick, disabled, size, variant, title, icon, ...props }) => {
    const sizeClass = styles[size] || styles.medium;
    const variantClass = styles[variant] || styles.primary;

    return (
        <button
            className={`${styles.pillButton} ${sizeClass} ${variantClass}`}
            onClick={onClick}
            disabled={disabled}
            title={title}
            {...props}
        >
            {icon && <span className={styles.icon}>{icon}</span>}
            {children}
        </button>
    );
};

PillButton.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    variant: PropTypes.oneOf(['default', 'primary', 'secondary']),
    title: PropTypes.string,
    icon: PropTypes.node,
};

PillButton.defaultProps = {
    size: 'medium',
    variant: 'primary',
    disabled: false,
    title: '',
    icon: null,
};

export default memo(PillButton);
